'use strict';

import {addCustomEventListener, hasClass, addClass, removeClass} from './helpers';

export const menu = (() => {
  const _app = document.getElementById('app');
  const _body = document.body;
  const menuServicesList = document.querySelectorAll('.app_menu__services__link');

  const openServicesMenuList = (list) => {
    list.forEach((link, key) => {

      setTimeout(() => {
        link.style.display = 'block';

        setTimeout(() => {
          addClass(link, 'is-open');
        }, 150);// time to practice styles

      }, 25 * key);// interval between element showing

    });
  };
  const closeServicesMenuList = (list, parent) => {
    list.forEach((link, key) => {

      setTimeout(() => {
        removeClass(link, 'is-open');

        setTimeout(() => {
          link.style.display = 'none';
        }, 320); // time to practice styles

      }, 25 * key); // interval between element closing

      if ((key + 1) === list.length) {
        removeClass(_app, 'menu-services--opened');
      }
    });
  };

  const servicesToggle = (e) => {
    const _headerMenu = document.querySelector('[data-header-menu]');
    const _headerMenuRect = _headerMenu.getBoundingClientRect();
    const _headerServicesLine = document.querySelector('[data-header-services-line]')
    const _headerList = document.querySelector('[data-services-menu-list]')
    const servicesListSize = window.innerWidth - _headerMenuRect.x;

    e.preventDefault();
    _headerServicesLine.style.width = `${servicesListSize}px`;
    _headerList.style.width = `${servicesListSize}px`;

    if (hasClass(e.target, 'active')) {
      removeClass(e.target, 'active');
    } else {
      addClass(e.target, 'active');
    }
    if (hasClass(_app, 'services--opened')) {
      removeClass(_app, 'services--opened');
    } else {
      addClass(_app, 'services--opened');
    }

    return false;
  };

  const menuToggle = (e) => {
    e.preventDefault();
    if (hasClass(_app, 'menu--opened')) {
      removeClass(_app, 'menu--opened menu-services--opened');
      removeClass(_body, 'is-locked');
      closeServicesMenuList(menuServicesList, _app);
    } else {
      addClass(_app, 'menu--opened');
      addClass(_body, 'is-locked');
      removeClass(_app, 'services--opened');
    }

    return false;
  };

  const menuServicesToggle = (e) => {
    e.preventDefault();
    if (hasClass(e.target, 'active')) {
      removeClass(e.target, 'active');
    } else {
      addClass(e.target, 'active');
    }

    if (!hasClass(_app, 'menu-services--opened')) {
      addClass(_app, 'menu-services--opened');
      openServicesMenuList(menuServicesList);
    } else {
      closeServicesMenuList(menuServicesList, _app);
    }

    return false;
  };

  const eventListeners = () => {
    addCustomEventListener('[data-type="services-toggle"]','click', servicesToggle);
    addCustomEventListener('[data-type="menu-toggle"]','click', menuToggle);
    addCustomEventListener('[data-type="menu-services-toggle"]','click', menuServicesToggle);
  };

  const closeAll = () => {
    const servItem = document.querySelector('[data-type="services-toggle"]');
    if (hasClass(servItem, 'active')) {
      removeClass(servItem, 'active');
    }
    const menuItem = document.querySelector('[data-type="menu-toggle"]');
    if (hasClass(menuItem, 'active')) {
      removeClass(menuItem, 'active');
    }
    const menuServItem = document.querySelector('[data-type="menu-services-toggle"]');
    if (hasClass(menuServItem, 'active')) {
      removeClass(menuServItem, 'active');
    }
    removeClass(_app, 'services--opened menu--opened menu-services--opened');
    removeClass(_body, 'is-locked');
    closeServicesMenuList(menuServicesList, _app);
  };

  const init = () => {
    if (!document.querySelector('header')) {
      return false;
    }
    eventListeners();
  };

  return {
    init,
    closeAll
  }
})();
